module.exports = __webpack_public_path__ + "static/media/content-panel-drag-button-2.cd11331c.svg";